import { IHall } from "../App";
import { locale } from "../MainApp";
import { GuestsList } from "./GuestsList";

type StandingReservationProps = {
    hall: IHall;
    minGuests: number;
    maxGuests: number;
    standingGuests: string[];
    onAddGuest: () => void;
    onRemoveGuest: (seatNo: number) => void;
    onChangeGuestName: (seatNo: number, name: string) => void;
    locale: locale;
};

export function StandingReservation(props: StandingReservationProps) {    
    return ( 
        <GuestsList
            guests={props.standingGuests}
            locale={props.locale}
            minGuests={props.minGuests}
            maxGuests={props.maxGuests}
            onAddGuest={() => props.onAddGuest()}
            onRemoveGuest={(seatNo) => props.onRemoveGuest(seatNo)}
            onChangeGuestName={(seatNo, name) => props.onChangeGuestName(seatNo, name)}
            tableName="Правостоящи"
        />
    );
}